import React from "react";
import "./Button.scss";

type Props = {
  type: "normal" | "negative" | "positive" | "neutral";
  className?: string;
  [key: string]: any;
  children: any;
};

function Button({ type, children, className, ...rest }: Props) {
  return (
    <div className={`button button-${type} ${className}`} {...rest}>
      {children}
    </div>
  );
}

export default Button;
